<template>
  <div v-if="state.active" class="mb-1 gift-wrapping-consent">
    <div class="form-check">
      <input id="giftWrapping" type="checkbox" class="form-check-input" :checked="state.checked" @change="update">
      <label class="form-check-label" for="giftWrapping">
        {{ state.text }}
      </label>
    </div>
    <div v-if="state.checked" class="giftWrappingLabelWrapper">
      <label class="form-control-label" for="giftWrappingLabel">{{ state.messageLabel }}</label>
      <textarea class="form-control" id="giftWrappingLabel" @change="updateMessage"></textarea>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      translations: state => state.translations,
      state: state => state.giftWrapping,
    }),
  },
  methods: {
    update (e) {
      this.$store.dispatch('giftWrapping/SET', e.target.checked);
    },
    updateMessage (e) {
      this.$store.commit('giftWrapping/SET_MESSAGE', e.target.value);
    }
  },
};
</script>
